import { action } from 'app/actions';

export const GET_ESGRADE_BY_GROUP = 'reports/application-detail/GET_ESGRADE_BY_GROUP';
export const getESGradeByGroup = (payload) => action(GET_ESGRADE_BY_GROUP, { payload });

export const GET_ESGRADE_BY_STUDENT = 'reports/application-detail/GET_ESGRADE_BY_STUDENT';
export const getESGradeByStudent = (payload) => action(GET_ESGRADE_BY_STUDENT, { payload });

export const GET_EVALUATION = 'reports/application-detail/GET_EVALUATION';
export const getEvaluation = (payload) => action(GET_EVALUATION, { payload });

export const GET_FILTERS_LEVEL_APPLICATION_REPORT =
  'reports/application-detail/GET_FILTERS_LEVEL_APPLICATION_REPORT';
export const getFiltersLevelApplicationReport = (payload) =>
  action(GET_FILTERS_LEVEL_APPLICATION_REPORT, { payload });

export const GET_DETAIL_EVALUATION_ALTERNATIVES =
  'reports/application-detail/GET_DETAIL_EVALUATION_ALTERNATIVES';
export const getDetailEvaluationAlternatives = (payload) =>
  action(GET_DETAIL_EVALUATION_ALTERNATIVES, { payload });

export const GET_ESGRADE_QUESTIONS_DETAIL =
  'reports/application-detail/GET_ESGRADE_QUESTIONS_DETAIL';
export const getESGradeQuestionsDetail = (payload) =>
  action(GET_ESGRADE_QUESTIONS_DETAIL, { payload });

export const GET_ES_QUESTION_DETAIL = 'reports/application-detail/GET_ES_QUESTION_DETAIL';
export const getESQuestionDetail = (payload) => action(GET_ES_QUESTION_DETAIL, { payload });

export const GET_FILTERS_QUESTIONS_APPLICATION_REPORT =
  'reports/application-detail/GET_FILTERS_QUESTIONS_APPLICATION_REPORT';
export const getFiltersQuestionsApplicationReport = (payload) =>
  action(GET_FILTERS_QUESTIONS_APPLICATION_REPORT, { payload });

export const GET_FILTERS_REPORTS = 'reports/application-detail/GET_FILTERS_REPORTS';
export const getFilterReports = (payload) => action(GET_FILTERS_REPORTS, { payload });

export const GET_ESGRADE_BY_RANKING_STUDENT =
  'reports/application-detail/GET_ESGRADE_BY_RANKING_STUDENT';
export const getESGradeByRankingStudent = (payload) =>
  action(GET_ESGRADE_BY_RANKING_STUDENT, { payload });

export const GET_ES_FILTERS_COMPONENTS = 'reports/components/getESFiltersComponents';
export const getESFiltersComponents = (payload) => action(GET_ES_FILTERS_COMPONENTS, { payload });

export const GET_ESGRADE_BY_DISCIPLINE = 'reports/components/getESGradeByDiscipline';
export const getESGradeByDiscipline = (payload) => action(GET_ESGRADE_BY_DISCIPLINE, { payload });

export const GET_ES_QUESTIONS_DETAILS_BY_COMPONENTS =
  'reports/components/getESQuestionsDetailsByComponents';
export const getESQuestionsDetailsByComponents = (payload) =>
  action(GET_ES_QUESTIONS_DETAILS_BY_COMPONENTS, { payload });

export const GET_ESGRADE_BY_ABILITY = 'reports/abilities/getESGradeByAbility';
export const getESGradeByAbility = (payload) => action(GET_ESGRADE_BY_ABILITY, { payload });

export const GET_ESGRADE_REPORT_STUDENT = 'reports/application-detail/GET_ESGRADE_REPORT_STUDENT';
export const getESGradeReportStudent = (payload) => action(GET_ESGRADE_REPORT_STUDENT, { payload });

export const GET_ESGRADE_DETAIL_BY_STUDENT =
  'reports/application-detail/GET_ESGRADE_DETAIL_BY_STUDENT';
export const getESGradeDetailByStudent = (payload) =>
  action(GET_ESGRADE_DETAIL_BY_STUDENT, { payload });

export const GET_ESGRADE_DETAIL_ALTERNATIVE_REPORT =
  'reports/application-detail/GET_ESGRADE_DETAIL_ALTERNATIVE_REPORT';
export const getESGradeDetailAlternativeReport = (payload) =>
  action(GET_ESGRADE_DETAIL_ALTERNATIVE_REPORT, { payload });

export const GET_ES_EVALUATIONS_CICLE_STUDENT =
  'reports/application-detail/GET_ES_EVALUATIONS_CICLE_STUDENT';
export const getESEvaluationsCicleStudent = (payload) =>
  action(GET_ES_EVALUATIONS_CICLE_STUDENT, { payload });

export const GET_ESGRADE_STUDENT_QUESTIONS =
  'reports/application-detail/GET_ESGRADE_STUDENT_QUESTIONS';
export const getESGradeStudentQuestions = (payload) =>
  action(GET_ESGRADE_STUDENT_QUESTIONS, { payload });

export const GET_STUDENTS_ANSWERS_QUESTION_REPORT =
  'reports/application-detail/GET_STUDENTS_ANSWERS_QUESTION_REPORT';

export const getStudentsAnswersQuestionReport = (payload) =>
  action(GET_STUDENTS_ANSWERS_QUESTION_REPORT, { payload });

export const GET_ESSAY_SSO_URL = 'reports/application-detail/GET_ESSAY_SSO_URL';
export const getEssaySsoUrl = (payload) => action(GET_ESSAY_SSO_URL, { payload });

export const RESET_ASSESSMENT_PANEL = 'reports/application-detail/RESET_ASSESSMENT_PANEL';
export const resetAssessmentPanel = () => action(RESET_ASSESSMENT_PANEL);

export const GET_ESGRADE_COMPARATIVE_BY_STUDENT =
  'reports/application-detail/GET_ESGRADE_COMPARATIVE_BY_STUDENT';
export const getESGradeComparativeByStudent = (payload) =>
  action(GET_ESGRADE_COMPARATIVE_BY_STUDENT, { payload });
